import { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  Bus,
  NotificationManager,
  SiteConfigManager,
  StorageManager,
  useApplicationState,
  useUserMessages,
} from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';

import { POPUP_MESSAGES_STORAGE_KEY } from 'common/constants';
import { useMessagesTabConfig } from 'src/hooks/useMessagesTabConfig';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { messages: messagesPath } = clientProfileRoutes;

export const useShowMessagesPopup = () => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const { authenticated } = useApplicationState();
  const { pathname } = useLocation();

  const { push } = useHistory();
  const { unreadMessagesCount } = useUserMessages();
  const messagesTab = useMessagesTabConfig();

  const isPopupShowed = StorageManager.getItem(POPUP_MESSAGES_STORAGE_KEY);

  const onConfirmHandler = useCallback(
    () => push(`${clientProfilePath}/${messagesPath}`),
    [clientProfilePath, push],
  );

  Bus.on(Bus.events.auth.logout, () => {
    StorageManager.removeItem(POPUP_MESSAGES_STORAGE_KEY);
  });

  useEffect(() => {
    if (
      !authenticated ||
      !unreadMessagesCount ||
      isPopupShowed ||
      pathname.includes('/game') ||
      pathname.includes('/virtual-game') ||
      !messagesTab?.isActive
    )
      return;

    NotificationManager.display({
      data: {
        onConfirm: onConfirmHandler,
      },
      type: 'messages',
    });

    StorageManager.setItem(POPUP_MESSAGES_STORAGE_KEY, 'true');
  }, [authenticated, isPopupShowed, messagesTab?.isActive, onConfirmHandler, pathname, unreadMessagesCount]);
};
